import React, { Component } from "react";
import KheshtiTabTileItem from "./items/tile";
import KheshtiTabBackgroundItem from "./items/kheshtiBackground";

export default class KheshtiTabItems extends Component {
  render() {
    return (
      <ul className="ul-background-select">
        <KheshtiTabTileItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
        <KheshtiTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
        />
      </ul>
    );
  }
}
